module.exports = __webpack_public_path__ + "src/img/add.611b0ba9.svg";